import { useField } from "formik";
import React from "react";
import { Form, Label } from "semantic-ui-react";

const QueueItemValue = ({ label, type, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  const getInputType = () => {
    if (type === "say") return "text";
    if (type === "play") return "url";
    if (type === "pause") return "number";
    throw new Error("Unknown Type");
  };
  return (
    <Form.Field>
      {/* <label>{label}</label> */}
      <input
        min='1'
        max='60'
        name={field.name}
        defaultValue={field.value}
        type={getInputType()}
        onBlur={(e) => helpers.setValue(e.currentTarget.value)}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default QueueItemValue;
